export default __webpack_public_path__ + "static/media/user.fe456e3e.svg";